/**
 * RoleBadge — brand-tinted identity chip for a staff role.
 *
 * Uses the brand tint (#EDE9FE) per the design system's "brand tint for role
 * badges / tags" rule — role/identity is the one place brand purple appears
 * outside navigation.
 */
import type { CSSProperties } from 'react';
import { colors, tints } from '../theme';

const ROLE_LABELS: Record<string, string> = {
  staff_admin: 'Staff Admin',
  pas: 'PAS',
  bas: 'BAS',
  finance: 'Finance',
  retention: 'Retention',
  state_ops: 'State Ops',
  case_management: 'Case Mgmt',
  clinical: 'Clinical',
  supervisor: 'Supervisor',
  cfo: 'CFO',
};

/** Human label for a role key (falls back to a humanized version). */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role.replace(/_/g, ' ');
}

export interface RoleBadgeProps {
  role: string;
  style?: CSSProperties;
}

export function RoleBadge({ role, style }: RoleBadgeProps) {
  return <span style={{ ...base, ...style }}>{roleLabel(role)}</span>;
}

const base: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 10px',
  fontSize: '0.74rem',
  fontWeight: 600,
  borderRadius: 999,
  background: tints.brand,
  color: colors.brandActive,
  whiteSpace: 'nowrap',
};
